import { BillingPlan } from '@cycle-app/graphql-codegen';
import { CycleLogo, ToasterTitle, typo } from '@cycle-app/ui';
import { useEffect } from 'react';
import styled from 'styled-components';

import { BillingBadge } from 'src/components/BillingBadge';
import { useProduct } from 'src/hooks/api/useProduct';
import { addToaster } from 'src/utils/toasters.utils';

let productId: string | undefined;
let plan: BillingPlan | undefined;

export const useCycleProToaster = () => {
  const { product } = useProduct();

  useEffect(() => {
    const newPlan = product?.plan;

    if (productId === product?.id && plan === BillingPlan.Free && newPlan === BillingPlan.Standard) {
      addToaster({
        duration: 'infinite',
        children: (
          <Content>
            <LogoContainer>
              <CycleLogo size={48} />
              <Badge>Pro</Badge>
            </LogoContainer>
            <ToasterTitle>Welcome to Cycle Pro</ToasterTitle>
            Turn product feedback into revenue.
          </Content>
        ),
      });
    }
    plan = newPlan;
    productId = product?.id;
  }, [product]);
};

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 16px 0 16px 16px;
`;

const LogoContainer = styled.div`
  display: inline-flex;
  position: relative;
`;

export const Badge = styled(BillingBadge)`
  position: absolute;
  border-radius: 22px;
  height: 18px;
  padding: 0 7px;
  right: -38%;
  ${typo.tiny600}
  box-shadow: none;
  background-color: ${p => p.theme.colors.billing.plan.standard.bg};
`;
